import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { EmailVerificationError } from '@ppl/email-verification-shared';


@Component({
    selector: 'ppl-email-verification-verification-needed',
    templateUrl: './email-verification-verification-needed.component.html',
    styleUrl: './email-verification-verification-needed.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailVerificationVerificationNeededComponent {

  @Input() email: string;

  @Input() error: EmailVerificationError = null;
  @Input() loading = false;

  @Output() resendEmail = new EventEmitter();

  onResendEmail() {
    this.resendEmail.emit();
  }
}

